import { render, staticRenderFns } from "./NewsSlider.vue?vue&type=template&id=73ec22ed"
import script from "./NewsSlider.vue?vue&type=script&lang=js"
export * from "./NewsSlider.vue?vue&type=script&lang=js"
import style0 from "./NewsSlider.vue?vue&type=style&index=0&id=73ec22ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports